import { SETUPINTENT_ATTACH_ERROR, PAYMENT_ERROR } from "containers/Stripe/services/constants"
import { SUBMIT_SURVEY_REQUEST } from "containers/Survey/services/constants"
import { Answer } from "containers/Survey/types"
import { ResponsePrice } from "types/payload"
import { Action, Message } from "types/redux"
import { PaymentStore } from "types/store"

import { TELEEXPERTISE_CREATE_REQUEST, TELEEXPERTISE_CREATE_SUCCESS } from "containers/Teleexpertise/services/constants"

import {
  PAYMENT_REQUIRES_ACTION,
  PRICE_SUCCESS,
  RESET_PAYMENT_STORE,
  TLC_ERROR,
  TLC_REQUEST,
  TLC_SUCCESS,
} from "./constants"

const initialState: Partial<PaymentStore> = {
  loading: false,
  success: false,
  teleexpertiseSent: false,
}

const PaymentReducer = (
  state = initialState,
  action: Action<Answer[] | Message | ResponsePrice>
): Partial<PaymentStore> => {
  switch (action.type) {
    case SUBMIT_SURVEY_REQUEST:
      return {
        ...state,
        answers: action.payload as Answer[],
        message: undefined,
      }
    case TLC_REQUEST:
    case TELEEXPERTISE_CREATE_REQUEST:
    case PAYMENT_REQUIRES_ACTION:
      return { ...state, loading: true, message: undefined }
    case TLC_SUCCESS:
      return { ...state, loading: false, success: true, call: action.payload as any }
    case TELEEXPERTISE_CREATE_SUCCESS:
      // The teleexpertise exists server-side from here on
      return { ...state, loading: false, success: true, teleexpertiseSent: true }
    case PRICE_SUCCESS:
      return { ...state, price: action.payload as ResponsePrice }
    case "SETUP_PAYMENT_INTENT_SUCCESS":
      return {
        ...state,
        paymentIntent: action.payload
      }
    case TLC_ERROR:
    case SETUPINTENT_ATTACH_ERROR:
    case PAYMENT_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        message: action.payload as Message,
      }
    case RESET_PAYMENT_STORE:
      return { ...initialState }
    default:
      return { ...state }
  }
}

export default PaymentReducer
